import React from 'react';

const UserGuide: React.FC = () => {
  return (
    <div className="w-full min-h-screen bg-white py-12 px-6">
      <div className="max-w-[1300px] mx-auto">
        <div className='h-[100vh] w-[100%] flex justify-center items-center'>
          <iframe
            src="https://demo.arcade.software/6MgMeYlglj9Sr5tsnxRP?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true"
            title="All Aboard User Guide"
            frameBorder="0"
            loading="lazy"
            allowFullScreen
            allow="clipboard-write"
            className="w-full h-full"
            style={{ colorScheme: 'light' }}
          />
        </div>
      </div>
    </div>
  );
};

export default UserGuide;
